import {useCallback} from 'react'
import CustomBox from '../../../components/common/CustomBox'
import SearchIcon from '@mui/icons-material/Search'
import {InputAdornment, TextField} from '@mui/material'
import PropTypes from 'prop-types'

const SearchPanel = ({searchTerm, updateSearchTerm}) => {
  const handleOnChange = useCallback(
    (e) => {
      updateSearchTerm(e.target.value)
    },
    [updateSearchTerm]
  )
  return (
    <CustomBox display='flex' flexDirection='row' alignItems='center'>
      <TextField
        size='small'
        variant='outlined'
        margin='normal'
        fullWidth
        value={searchTerm}
        onChange={handleOnChange}
        placeholder='Search users'
        id='search'
        inputProps={{'aria-labelledby': 'search'}}
        InputProps={{
          sx: {
            height: '32px',
            borderRadius: (theme) => theme.spacing(0.5),
            fontSize: (theme) => theme.typography.body1.fontSize,
            '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: (theme) => theme.palette.primary.main
            }
          },
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon sx={{height: '20px'}} />
            </InputAdornment>
          )
        }}
      />
    </CustomBox>
  )
}

SearchPanel.propTypes = {
  searchTerm: PropTypes.string,
  updateSearchTerm: PropTypes.func
}

export default SearchPanel
